import { useUserQuery } from '../features/user/useUserQuery';
import DataExtractionService from '../services/dataExtraction/DataExtractionService';

export const isInternalDomain = (domains: string[], userDomain: string): boolean => {
  return domains.length === 1 && domains[0] === userDomain;
};

export const useIsInternalDomain = (domains: string[] = []) => {
  const userQuery = useUserQuery();
  const userDomain = DataExtractionService.meeting.extractDomainFromEmail(userQuery.data?.email || '');
  return isInternalDomain(domains, userDomain);
};
